import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{t \"placeholders.coming_soon\"}}\n",{ moduleName: "uplisting-frontend/pods/clients/settings/template.hbs" })